module.exports = __webpack_public_path__ + "img/hawthorn.5e188399.png";